// import React from 'react';
// import styled from 'styled-components/macro';

// import DatePickerHeader from '../DatePickerHeader';
// import { StyledDateRange } from './DatePicker.styles';

// function ReactDateRange({ prefix, disabled, excludeDateIntervals, invalid, error, onChange, ...props }) {
//   return (
//     <StyledDateRange
//       disabled={disabled}
//       excludeDateIntervals={excludeDateIntervals}
//       prefix={prefix}
//       invalid={invalid || error}
//       renderCustomHeader={({
//         date,
//         changeYear,
//         changeMonth,
//         decreaseMonth,
//         increaseMonth,
//         prevMonthButtonDisabled,
//         nextMonthButtonDisabled,
//       }) => (
//         <DatePickerHeader
//           date={date}
//           changeYear={changeYear}
//           changeMonth={changeMonth}
//           decreaseMonth={decreaseMonth}
//           increaseMonth={increaseMonth}
//           prevMonthButtonDisabled={prevMonthButtonDisabled}
//           nextMonthButtonDisabled={nextMonthButtonDisabled}
//         />
//       )}
//       {...props}
//       onChange={_ => {
//         onChange({ target: { value: _, name: props.name } });
//       }}
//     />
//   );
// }

// export default ReactDateRange;

import React from 'react';
import styled from 'styled-components/macro';

import DatePickerHeader from '../DatePickerHeader';
import { StyledDateRange } from './DatePicker.styles';

function ReactDateRange({
  prefix,
  disabled,
  excludeDateIntervals,
  invalid,
  error,
  onChange,
  value,
  selectsRange = false, // ✅ control single or range mode
  ...props
}) {
  return (
    <StyledDateRange
      disabled={disabled}
      excludeDateIntervals={excludeDateIntervals}
      prefix={prefix}
      invalid={invalid || error}
      selectsRange={selectsRange} // ✅ dynamically enable range mode
      startDate={selectsRange && value?.[0] ? new Date(value[0]) : null}
      endDate={selectsRange && value?.[1] ? new Date(value[1]) : null}
      selected={!selectsRange && value ? new Date(value) : null}
      dateFormat="MMM dd, yyyy"
      popperPlacement="bottom-start"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <DatePickerHeader
          date={date}
          changeYear={changeYear}
          changeMonth={changeMonth}
          decreaseMonth={decreaseMonth}
          increaseMonth={increaseMonth}
          prevMonthButtonDisabled={prevMonthButtonDisabled}
          nextMonthButtonDisabled={nextMonthButtonDisabled}
        />
      )}
      {...props}
      onChange={dates => {
        if (selectsRange) {
          // ✅ Handle range selection
          const [start, end] = dates || [];
          onChange({
            target: {
              value: [start ? start.toISOString() : null, end ? end.toISOString() : null],
              name: props.name,
            },
          });
        } else {
          // ✅ Handle single date
          const date = dates;
          onChange({
            target: {
              value: date ? date.toISOString() : null,
              name: props.name,
            },
          });
        }
      }}
    />
  );
}

export default ReactDateRange;
